"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletionMessage = void 0;
class CompletionMessage {
    constructor() {
    }
    static getAttributeTypeMap() {
        return CompletionMessage.attributeTypeMap;
    }
}
exports.CompletionMessage = CompletionMessage;
CompletionMessage.discriminator = undefined;
CompletionMessage.attributeTypeMap = [
    {
        "name": "content",
        "baseName": "content",
        "type": "string",
        "format": ""
    },
    {
        "name": "role",
        "baseName": "role",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=CompletionMessage.js.map